import { TutorialVideoCardProps } from "./types";

export function TutorialVideoCard({ title, onClick }: TutorialVideoCardProps) {
  return (
    <div className="flex-1 flex flex-col justify-end">
      <button
        onClick={onClick}
        className="bg-cede-bg-dark rounded-medium p-4 flex items-center gap-4 hover:bg-cede-bg-component transition-colors cursor-pointer text-left"
      >
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 17.2389V2.59235C0 1.0249 1.72118 0.0666484 3.05353 0.892331L14.3713 7.90617C15.6048 8.67058 15.6392 10.453 14.436 11.2643L3.11826 18.897C1.78989 19.7929 0 18.8411 0 17.2389Z"
            fill="white"
          />
        </svg>

        <p className="mb-0 text-cede-text-primary text-base">{title}</p>
      </button>
    </div>
  );
}
